import CryptoJS from "crypto-js";

const ENCRYPT_SECRET_KEY = import.meta.env.VITE_ENCRYPT_SECRET_KEY;
const DECRYPT_SECRET_KEY = import.meta.env.VITE_DECRYPT_SECRET_KEY;

export function encryptData(data) {
  try {
    const jsonString = JSON.stringify(data);
    // console.log("-----------------",ENCRYPT_SECRET_KEY)
    const key = CryptoJS.SHA256(ENCRYPT_SECRET_KEY);
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(jsonString, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return {
      data: encrypted.ciphertext.toString(CryptoJS.enc.Hex),
      iv: iv.toString(CryptoJS.enc.Hex),
      encrypted: true,
    };
  } catch (error) {
    console.error("Encryption failed:", error);
    return data;
  }
}

export function decryptData(data) {
  const { data: encryptedData, iv: ivHex } = data;
  const key = CryptoJS.SHA256(DECRYPT_SECRET_KEY);

  const iv = CryptoJS.enc.Hex.parse(ivHex);

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Hex.parse(encryptedData) },
    key,
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 },
  );
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}
